export { NavigationAlt as default } from './NavigationAlt';
